import _slicedToArray from "/home/runner/work/me/me/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var e = Object.defineProperty,
    r = Object.getOwnPropertySymbols,
    t = Object.prototype.hasOwnProperty,
    n = Object.prototype.propertyIsEnumerable,
    l = function l(r, t, n) {
  return t in r ? e(r, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : r[t] = n;
},
    o = function o(e, _o) {
  for (var a in _o || (_o = {})) {
    t.call(_o, a) && l(e, a, _o[a]);
  }

  if (r) {
    var _iterator = _createForOfIteratorHelper(r(_o)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        n.call(_o, a) && l(e, a, _o[a]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    a = ("undefined" != typeof require && require, function (e, l) {
  var o = {};

  for (var a in e) {
    t.call(e, a) && l.indexOf(a) < 0 && (o[a] = e[a]);
  }

  if (null != e && r) {
    var _iterator2 = _createForOfIteratorHelper(r(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var a = _step2.value;
        l.indexOf(a) < 0 && n.call(e, a) && (o[a] = e[a]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return o;
});

import s, { useEffect as c, useRef as i, createElement as u, cloneElement as d, Fragment as f } from "react";
import { hydrate as b } from "react-dom";

var y = "undefined" == typeof window,
    p = {
  suppressHydrationWarning: !0,
  dangerouslySetInnerHTML: {
    __html: ""
  }
},
    v = function v(e, _ref, l) {
  var _ref$renderer = _ref.renderer,
      r = _ref$renderer === void 0 ? b : _ref$renderer,
      t = _ref.fallback,
      n = _ref.afterRender;
  c(function () {
    e.current && e.current.innerHTML || t && (r(t, e.current), null == n || n());
  }, l);
},
    g = function g(e, _ref2) {
  var r = _ref2.onIntersectIn,
      t = _ref2.onIntersectOut,
      n = _ref2.root,
      l = _ref2.rootMargin,
      o = _ref2.threshold,
      a = _ref2.target;
  c(function () {
    if (!e.current) return;
    var s = a ? a(e.current) : e.current,
        c = new IntersectionObserver(function (_ref3, n) {
      var _ref4 = _slicedToArray(_ref3, 1),
          e = _ref4[0];

      e.isIntersecting ? null == r || r({
        IntersectionObserverEntry: e,
        IntersectionObserver: n,
        target: s
      }) : null == t || t({
        IntersectionObserverEntry: e,
        IntersectionObserver: n,
        target: s
      });
    }, {
      root: n,
      rootMargin: l,
      threshold: o
    });
    return s && c.observe(s), c.disconnect;
  }, [n, l, o]);
},
    h = function h(e) {
  var r = e,
      t = r.children,
      _r$fallback = r.fallback,
      n = _r$fallback === void 0 ? t : _r$fallback,
      l = r.as,
      s = r.onFallback,
      c = r.style,
      d = a(r, ["children", "fallback", "as", "onFallback", "style"]);
  var f = i(null),
      b = null != l ? l : "div";
  return v(f, {
    fallback: n,
    afterRender: s
  }, []), y ? u(b, o({
    style: o({
      display: "contents"
    }, c)
  }, d), t) : u(b, o(o({
    ref: f,
    style: o({
      display: "contents"
    }, c)
  }, d), p));
},
    O = function O(e) {
  var r = e,
      t = r.children,
      _r$fallback2 = r.fallback,
      n = _r$fallback2 === void 0 ? t : _r$fallback2,
      l = r.as,
      c = r.onFallback,
      h = r.style,
      _r$target = r.target,
      O = _r$target === void 0 ? s.createElement("div", null) : _r$target,
      I = r.root,
      k = r.rootMargin,
      m = r.threshold,
      w = a(r, ["children", "fallback", "as", "onFallback", "style", "target", "root", "rootMargin", "threshold"]);
  var M = i(null),
      E = null != l ? l : "div",
      j = d(O, {
    key: "target"
  }),
      F = d(t, {
    key: "children"
  });
  return v(M, {
    fallback: u(f, null, [j, n])
  }, []), g(M, {
    onIntersectIn: function onIntersectIn(_ref5) {
      var e = _ref5.IntersectionObserver,
          r = _ref5.target;
      r && e.unobserve(r), b(u(f, null, [j, F]), M.current);
    },
    target: function target(e) {
      return e.firstElementChild;
    }
  }), y ? u(E, o({
    style: o({
      display: "contents"
    }, h)
  }, w), [j, F]) : u(E, o(o({
    ref: M,
    style: o({
      display: "contents"
    }, h)
  }, w), p));
};

export { O as Intersection, h as Static, v as useFallback, g as useIntersection };